__turbopack_context__.v({
  "container": "index-module__tjl08q__container",
  "containerWrapper": "index-module__tjl08q__containerWrapper",
  "header": "index-module__tjl08q__header",
  "image": "index-module__tjl08q__image",
  "item": "index-module__tjl08q__item",
  "itemsWrapper": "index-module__tjl08q__itemsWrapper",
  "overlay": "index-module__tjl08q__overlay",
  "text": "index-module__tjl08q__text",
});
